export default __webpack_public_path__ + "static/media/client-23.3f5a674d.webp";